import { render } from "./SelectionSetTree.vue?vue&type=template&id=c08e22be&scoped=true&ts=true"
import script from "./SelectionSetTree.vue?vue&type=script&lang=ts"
export * from "./SelectionSetTree.vue?vue&type=script&lang=ts"

import "./SelectionSetTree.vue?vue&type=style&index=0&id=c08e22be&scoped=true&lang=scss"

import exportComponent from "/home/ubuntu/workspace/OneTegProdDeployment/ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c08e22be"]])

export default __exports__